import React from "react";
import { Helmet } from "react-helmet-async";

const DOMAIN = "https://bhutanmorningteerresult.in";

export default function Seo({
  title,
  description,
  path = "/",
  jsonLd,
  breadcrumb,
}) {
  const canonical = `${DOMAIN}${path}`;
  const ogImage = `${DOMAIN}/og-image.jpg`;
  const schemas = [];

  // Organization schema (site-wide, helps Google show branding/logo)
  schemas.push({
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Bhutan Morning Teer Result",
    alternateName: "Bhutan Morning Teer",
    url: DOMAIN,
    logo: `${DOMAIN}/logo512.png`,
    image: ogImage,
  });

  // WebSite schema (site-wide)
  schemas.push({
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Bhutan Morning Teer Result",
    alternateName: "Bhutan Morning Teer Result Today",
    url: DOMAIN,
    potentialAction: {
      "@type": "SearchAction",
      target: `${DOMAIN}/previous-result/?q={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  });

  if (breadcrumb && breadcrumb.length) {
    schemas.push({
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: breadcrumb.map((b, i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: b.name,
        item: `${DOMAIN}${b.path}`,
      })),
    });
  }

  if (jsonLd) schemas.push(jsonLd);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      {schemas.map((s, i) => (
        <script type="application/ld+json" key={i}>
          {JSON.stringify(s)}
        </script>
      ))}
    </Helmet>
  );
}
